import React, {useState} from "react"
import api from "../services/apiClient";
import AuthService from '../services/authentication'
import {useHistory, Prompt} from "react-router-dom"
import surveyManager from '../../services/surveyManager'

import MixtureImage from 'images/mixture_image.png'

import { Button, InputGroup, Input, Textarea, Label, Alert } from "../ui"

import {
  useOrder,
  updateLineItem,
  sendOrderEmail
} from '../data/order'

import MixtureLineItem from './MixtureLineItem';

function PractitionerOrderDetail(props) {

  let auth = AuthService.useAuth()
  let history = useHistory()
  const {order,isLoading, isError, mutate} = useOrder(auth.authHeader())

  const [noteDrafts, setNoteDrafts] = useState({});
  const [markupDrafts, setMarkupDrafts] = useState({});
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const mixturesValid = () => order.mixture_line_items.some(item => item.mixture && Object.keys(item.herbs).length === 0)

  const handleLineItemChange = async (lineItem, property, value, mixture=false) => {
    const updatedOrder = JSON.parse(JSON.stringify(order));

    const lineItemsKey = mixture ? 'mixture_line_items' : 'product_line_items';

    const lineItemIndex = updatedOrder[lineItemsKey].findIndex(item => item.id === lineItem.id);

    if (lineItemIndex === -1) {
      console.error(`Line item with ID ${lineItem.id} not found`);
      return;
    }

    updatedOrder[lineItemsKey][lineItemIndex][property] = value;

    const options = {
      optimisticData: updatedOrder,
      rollbackOnError(error) {
        return error.name !== 'AbortError'
      },
      populateCache: false,
    }
    mutate(
      updateLineItem({
        line_item_id: lineItem.id,
        mixture: mixture,
        property: property,
        value: value,
        auth_header: auth.authHeader()
      }),
      options
    );
  }

  const quantityForm = lineItem => {
    return (
      <form className="inline-flex items-center">
        <InputGroup>
          <Button disabled={lineItem.quantity == 0} variant="secondary" onClick={() => handleLineItemChange(lineItem, 'quantity', lineItem.quantity - 1, lineItem.mixture)}>-</Button>
          <Input style={{maxWidth: '3rem', textAlign: 'center'}} value={lineItem.quantity || 0} readOnly />
          <Button variant="secondary" onClick={() => handleLineItemChange(lineItem, 'quantity', lineItem.quantity + 1, lineItem.mixture)}>+</Button>
        </InputGroup>
      </form>
    )
  }

  const renderLineItems = () => {
    console.log([...order.product_line_items, ...order.mixture_line_items]);

    const renderMixtureLineItems = () => {
      return order.mixture_line_items.map((lineItem) => (
        <MixtureLineItem
          mixture={lineItem}
          noteDrafts={noteDrafts}
          setNoteDrafts={setNoteDrafts}
          markupDrafts={markupDrafts}
          setMarkupDrafts={setMarkupDrafts}
          handleDraftNoteChange={handleDraftNoteChange}
          handleDraftMarkupChange={handleDraftMarkupChange}
          deleteMixture={deleteMixture}
          saveOrder={saveOrder}
        />
      ));
    };

    const renderProductLineItems = () => {
      return order.product_line_items.map((lineItem) => (
        <div key={lineItem.id} className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-2 flex justify-center">
            <img
              className="rounded border border-gray-200 bg-white p-1"
              src={lineItem.image_url}
              style={{aspectRatio: '1/1', width: '100%', objectFit: 'contain', objectPosition: 'center'}}
            />
          </div>
          {renderProductLineItemDetails(lineItem)}
        </div>
      ));
    };

    return (
      <>
        {renderProductLineItems()}
        {renderMixtureLineItems()}
      </>
    );
  };

  const handleDraftNoteChange = (lineItemId, draftNote) => {
    setNoteDrafts({ ...noteDrafts, [lineItemId]: draftNote });
    setUnsavedChanges(true);
  }

  const deleteMixture = mixture => {
    api.delete(`/api/mixtures/${mixture.id}`, { headers: auth.authHeader() }).then(response => {
      }
    ).then(response => {
      mutate()
    })
    .catch(error => {
      alert('Could not delete that mixture. Please reload the page and try again.')
    })
  }

  const renderProductLineItemDetails = lineItem => {
    return (
      <>
        <div className="col-span-7">
          <div className="flex flex-wrap content-between h-full">
            <div className="w-full">
              <h4 className="text-xl font-bold tracking-tight text-gray-900 pb-2">{lineItem.name}</h4>
            </div>
            <div className="w-full">
              {quantityForm(lineItem)}
              <Textarea
                name="notes"
                placeholder="Notes.."
                value={noteDrafts[lineItem.id] !== undefined ? noteDrafts[lineItem.id] : lineItem.note}
                onChange={(e) => handleDraftNoteChange(lineItem.id, e.target.value)}
                className="my-2"
              />
              <div className="">
                {renderPricingOptions(lineItem)}
                {renderMarkupForm(lineItem)}
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-3 flex content-end justify-end flex-wrap">
          <h4 className="text-2xl">${(lineItem.patient_price * lineItem.quantity).toFixed(2)}</h4>
        </div>
      </>
    )
  }

  const renderPricingOptions = lineItem => {
    return (
      <form className="flex items-center flex-wrap">
        <Label className="font-bold me-2 mb-0">Pricing:</Label>
        <Label className="inline-flex items-center me-2 mb-0 font-normal">
          <input
            className="me-1"
            type="radio"
            onChange={() => handleLineItemChange(lineItem, 'use_rrp', !lineItem.use_rrp)}
            checked={lineItem.use_rrp}
          />
          RRP
        </Label>
        <Label className="inline-flex items-center mb-0 font-normal">
          <input
            className="me-1"
            type="radio"
            onChange={() => handleLineItemChange(lineItem, 'use_rrp', !lineItem.use_rrp)}
            checked={!lineItem.use_rrp}
          />
          Markup
        </Label>
      </form>
    )
  }

  const handleDraftMarkupChange = (lineItemId, draftMarkup) => {
    if (draftMarkup < 0) draftMarkup = 0
    if (draftMarkup >= 300) draftMarkup = 300
    setMarkupDrafts({ ...markupDrafts, [lineItemId]: draftMarkup });
    setUnsavedChanges(true);
  }

  const renderMarkupForm = lineItem => {
    return (
      <form>
        <InputGroup style={lineItem.use_rrp ? {opacity: 0.2, pointerEvents: 'none'} : {}}>
          <Input
            style={{maxWidth: '10em'}}
            name="markup"
            type="number"
            placeholder="0"
            onChange={(e) => handleDraftMarkupChange(lineItem.id, e.target.value)}
            value={markupDrafts[lineItem.id] !== undefined ? markupDrafts[lineItem.id] : lineItem.markup}
            min={0}
            step={0.01}
          />
          <InputGroup.Text>%</InputGroup.Text>
        </InputGroup>
      </form>
    );
  }

  const processDrafts = async (drafts, attribute) => {
    for (let id in drafts) {
      let lineItem = order.product_line_items.find(item => item.id == id) || order.mixture_line_items.find(item => item.id == id);
      if (lineItem && drafts[id] !== lineItem[attribute]) {
        await handleLineItemChange(lineItem, attribute, drafts[id], lineItem.mixture);
      }
    }
  }

  const saveOrder = async () => {
    await processDrafts(noteDrafts, 'note');
    await processDrafts(markupDrafts, 'markup');
    setUnsavedChanges(false);
  }

  const handleAddMoreProducts = async () => {
    await saveOrder();
    history.push('/order/edit');
  }

  const handleSendOrderEmail = async () => {
    await saveOrder();

    sendOrderEmail({order_id: order.id, auth_header: auth.authHeader()})
      .then(response => {
        mutate();
        // Get company code from auth user or order (ihal for AU, inzl for NZ)
        const companyCode = auth.user?.user?.company_code || order.company_code || 'ihal';
        surveyManager.triggerSurvey(order.id, companyCode);
        alert('Prescription has been sent to patient.');
        history.push('/');
      })
      .catch(error => {
        console.log(error);
        alert('Could not send that order. Please reload the page and try again.');
      });
  }

  if(isLoading) return <div>Loading...</div>;
  if(isError) return <div>Error occurred!</div>;

  return (
    <>
      <Prompt
        when={unsavedChanges}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      {(Object.keys(order.product_line_items).length !== 0 || Object.keys(order.mixture_line_items).length !== 0) && renderLineItems()}
      <p className="text-gray-500 mt-4">All prices include GST.</p>
      <p className="text-gray-500">This prescription is valid for 6 months or until all products have been purchased.</p>
      <h4 className="text-xl font-bold mt-4">Patient Sub Total: ${order.totals.patient_total.toFixed(2)}</h4>
      {unsavedChanges && <Button onClick={saveOrder} className="mx-2 mt-2">Save</Button>}
      <Button onClick={handleAddMoreProducts} variant="secondary" className="me-2 mt-2">Add more products</Button>
      <Button
          variant="primary"
          className="mt-2"
          onClick={handleSendOrderEmail}
          disabled={
            (order.product_line_items.length === 0 && order.mixture_line_items.length === 0) ||
            mixturesValid()
          }
      >
        Send to Patient
      </Button>
      {mixturesValid() &&
        <Alert variant="danger"  className="mt-2">
          <p className="mb-0">
            One of your custom herbal formulations is incomplete. Please finish blending herbs or remove it from the order before sending to your patient.
          </p>
        </Alert>
      }
    </>
  )
}

export default PractitionerOrderDetail
